import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

export const useSalesOrderRestrictionsBySOId = (salesOrderId) => {
  const restrictions = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'restrictions',
    }),
  );
  return restrictions;
};

export const useEntitiesSalesOrder = (salesOrderId) => useSelector((state) => Global.selectEntitiesSalesOrderById(state, { salesOrderId }));

export const useEntitiesSalesOrders = (salesOrderIds) =>
  useSelector((state) => Global.selectEntitiesSalesOrdersByIds(state, { salesOrderIds }));

export const useEntitiesSalesOrderProperty = (salesOrderId, property) =>
  useSelector((state) => Global.selectEntitiesSalesOrderProperty(state, { salesOrderId, property }));

export const useEntitiesSalesOrdersByFulfillmentPlanId = (fulfillmentPlanId) =>
  useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );
